import script from "./WelcomeSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeSkeleton.vue?vue&type=style&index=0&id=76535411&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76535411"]])

export default __exports__